/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { queryShopSiteList } from '@/services/storeManage'

class AdsenseDisplayExtra {
    adsenseExtra = null

    _resolve = null
    _reject = null

    lock() {
        if (!this._resolve) {
            this._p = new Promise((resolve, reject) => {
                this._resolve = resolve
                this._reject = reject
            })
        }
    }

    unlock() {
        if (this._resolve) {
            this._resolve()
            this.clear()
        }
    }

    clear() {
        this._p = this._resolve = this._reject = null
    }

    static enqueueIfLocked(promise) {
        if (promise) {
            return promise
        }

        return Promise.resolve()
    }

    async refreshAdsenseExtra() {
        try {
            const { success, data } = await queryShopSiteList({
                isValid: true // 【已授权】且【已启用】的店铺才会生效
            })

            if (success) {
                const appPlatforms = Array.isArray(data) ? data.map(item => item.name) : []

                this.adsenseExtra = {
                    appPlatforms
                }
            } else {
                this.adsenseExtra = null
            }
        } catch (e) {
            console.error('queryShopSiteList not success', e)
        }
    }

    async retry() {
        this.lock()

        await this.refreshAdsenseExtra()

        this.unlock()
    }

    async getAdsenseExtra() {
        await AdsenseDisplayExtra.enqueueIfLocked(this._p)

        if (!this.adsenseExtra) {
            await this.retry()
        }

        return this.adsenseExtra
    }
}

export default AdsenseDisplayExtra
